module.exports = __webpack_public_path__ + "img/public/SiteIcons/creditIcon.svg?2b4ae154";